import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Classes = class Classes extends VuexModule {
    constructor() {
        super(...arguments);
        this.classes = [];
        this.cachedVersion = 0;
    }
    async fetchClasses() {
        const { data: classes, cachedVersion } = await fetchFromCache(this, 'classes', 'class');
        return { classes, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['classes', 'cachedVersion'] })
], Classes.prototype, "fetchClasses", null);
Classes = __decorate([
    Module({ namespaced: true, name: 'classes' })
], Classes);
export default Classes;
